import { render, staticRenderFns } from "./testRecords.vue?vue&type=template&id=17c7e3f8&scoped=true&"
import script from "./testRecords.vue?vue&type=script&lang=js&"
export * from "./testRecords.vue?vue&type=script&lang=js&"
import style0 from "./testRecords.vue?vue&type=style&index=0&id=17c7e3f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c7e3f8",
  null
  
)

export default component.exports